import {LanguageProfile, LanguagesService} from "../../../../common/languages";
import {resolve} from "../../../../container";
import {customElement, property, query} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import {GLOBAL} from "../../../../common/globals";
import {eventOccurredOutside, installEscapeHandlerOn} from "../../../../common/utils/events";
import {UnLitElement} from "../../../../common/elements";
import type {Nullable} from "../../../../bootstrap/common/types";
import {ManagingResources} from "../../../../common/lifetime";
import {trackingNavigationInteract} from "../../../../tracking/trackingAttributes";


@customElement("eop-desktop-language-switch")
export class EopDesktopLanguageSwitch extends ManagingResources(UnLitElement) {


    @property({attribute: true, reflect: true, type: Boolean})
    public open: boolean = false;
    @query(".language-dropdown")
    private dropdown: HTMLElement;

    private allLanguages: LanguageProfile[];
    private activeLanguage: LanguageProfile;

    public constructor(private languagesService: LanguagesService = resolve(LanguagesService)) {
        super();
    }

    public connectedCallback(): void {
        super.connectedCallback();
        this.allLanguages = this.languagesService.allLanguages();
        this.activeLanguage = this.languagesService.activeLanguage();

        installEscapeHandlerOn(this, () => this.closeFromEscapeKey());
    }

    public render(): Nullable<TemplateResult> {
        if (this.allLanguages.isEmpty()) {
            return null;
        }

        return html`
            <div class="language-switch-container">
                <button class="language-switch" @click=${this.toggle} ${trackingNavigationInteract("language-switch")}>
                    <span class="current-language-label">${this.activeLanguage.id.toUpperCase()}</span>
                </button>
                <div class="language-dropdown">${(this.renderLanguages())}</div>
            </div>
        `;
    }

    private renderLanguages(): TemplateResult[] {
        return this.allLanguages.map(lang => this.renderLanguageOption(lang));
    }

    private renderLanguageOption(lang: LanguageProfile): TemplateResult {
        if (this.activeLanguage.id === lang.id) {
            return html`
                <span class="language active">${(lang.name)}</span>
            `;
        } else {
            return html`
                <a href=${lang.href} class="link language inactive"
                   ${trackingNavigationInteract(lang.name, lang.href)}
                >${lang.name}</a>
            `;
        }
    }

    private toggle(): void {
        this.open = !this.open;
        if (this.open) {
            GLOBAL.bodyElement().addEventListener("click", this.close);
        }
    }

    private close = (event: Event): void => {
        if (eventOccurredOutside(event, this)) {
            this.open = false;
            GLOBAL.bodyElement().removeEventListener("click", this.close);
        }
    };

    private closeFromEscapeKey(): void {
        this.open = false;
        GLOBAL.bodyElement().removeEventListener("click", this.close);
    }
}
